<template>
    <div class="container">

        <div>
            <button type="button" class="btn btn-primary btn-sm m-1" @click="ShowAddAdminUserModal()">
            Add Admin User
            </button>
        </div>

        <span v-if="isDataFetched" class="d-flex justify-content-center">
            <div class="spinner-border text-primary">
                <span class="visually-hidden"></span>
            </div>
             Loading...
        </span>

        <div class="row m-2">
            <table class="table text-left bg-light text-dark table-hover col-12">
                <thead>
                    <tr class="h4 col-12">
                        <td>Name</td>
                        <td>Role</td>
                        <td>Edit</td>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="adminUser in adminUsers" v-bind:key="adminUser.userId" class="col-12">
                        <td>{{adminUser.name}}</td>
                        <td>{{adminUser.roleName}}</td>
                        <td @click="ShowUpdateModal(adminUser)">Edit</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <button type="button" class="btn btn-primary collapse" id="adminUserDetailModalButton" data-bs-toggle="modal" data-bs-target="#adminUserDetailModal">
        Launch adminUserDetailModal
        </button>

        <div class="modal" id="adminUserDetailModal" tabindex="999999">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title text-align-center text-primary fw-bold" v-if="isNewAdminUserToAdd">Enter New Admin User Information</h4>
                        <h4 class="modal-title text-align-center text-primary fw-bold" v-if="!isNewAdminUserToAdd">Update Admin User</h4>

                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">

                        <div class="row p-2 m-2 modal-body text-left">
                            <div class="row">
                                <span class="text-primary col-3">Name </span>
                                <input type="text" class="text-danger col-9" v-model="selectedAdminUser.name" placeholder="Enter Name">
                            </div>
                            <div class="row mt-2">
                                <span class="text-primary col-3">Password </span>
                                <input type="password" class="text-danger col-9" v-model="selectedAdminUser.password" :placeholder="isNewAdminUserToAdd ? 'Enter Password' : 'Leave blank to keep unchanged'">
                            </div>
                            <div class="row mt-2">
                                <span class="text-primary col-3">Description </span>
                                <input type="text" class="text-danger col-9" v-model="selectedAdminUser.description" placeholder="Enter Description">
                            </div>
                            <div class="row mt-2">
                                <span class="text-primary col-3">Role </span>
                                <select class="text-danger col-9" v-model="selectedAdminUser.roleId">
                                    <option v-for="role in roles" v-bind:key="role.roleId" :value="role.roleId">{{role.name}}</option>
                                </select>
                            </div>
                        </div>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                        <button type="button" v-if="!isNewAdminUserToAdd" @click="UpdateAdminUser()" class="btn btn-secondary" data-bs-dismiss="modal">Update Admin User</button>
                        <button type="button" v-if="isNewAdminUserToAdd" @click="CreateAdminUser()" class="btn btn-secondary" data-bs-dismiss="modal">Add Admin User</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import { toRaw } from 'vue';
import { isBoss } from '@/utils/auth';

export default({
name:'AdminUsersView',
props:{
    baseUrl:String
},
data() {
    return {
        adminUsers:[],
        roles:[],
        isDataFetched:false,
        selectedAdminUser:{},
        isNewAdminUserToAdd:false
    }
},
methods:{
    getAdminUsersList(){
        this.isDataFetched = true;
        let adminUsersRequestUrl = this.baseUrl + "AdminUsers/AdminUsers";
        let adminUsersRequestOptions = {
            method:"GET",
            headers:{
              "Authorization":"Bearer " + localStorage.token,
              "Content-Type" : "application/json"
            },
          };

          fetch(adminUsersRequestUrl, adminUsersRequestOptions)
          .then(response =>{
            return response.json();
          })
          .then(res =>{
            this.adminUsers = res.adminUsers;
            this.isDataFetched = false;
          })
          .catch(error=>{
            console.log("error encountered", error);
            this.isDataFetched = false;
          });
    },
    getRolesList(){
        let rolesRequestUrl = this.baseUrl + "AdminUsers/Roles";
        let rolesRequestOptions = {
            method:"GET",
            headers:{
              "Authorization":"Bearer " + localStorage.token,
              "Content-Type" : "application/json"
            },
          };

          fetch(rolesRequestUrl, rolesRequestOptions)
          .then(response =>{
            return response.json();
          })
          .then(res =>{
            this.roles = res.roles;
          })
          .catch(error=>{
            console.log("error encountered", error);
          });
    },
    CreateAdminUser(){
        let createAdminUserRequestUrl = this.baseUrl + "AdminUsers/CreateAdminUser";
        let createAdminUserRequestOptions = {
            method:"POST",
            headers:{
                "Authorization":`Bearer ${localStorage.token}`,
                "Content-Type":"application/json"
            },
            body:JSON.stringify(
                {
                    "name": this.selectedAdminUser.name,
                    "password": this.selectedAdminUser.password,
                    "description": this.selectedAdminUser.description,
                    "roleId": this.selectedAdminUser.roleId
                }
            )
        };

        fetch(createAdminUserRequestUrl, createAdminUserRequestOptions)
        .then(async response=>{
            const result = await response.json();

            if(response.ok){
                alert("Admin user added successfully!");
                await this.getAdminUsersList();
            }
            else{
                alert("Failed to add admin user. Please try again.");
                console.error("Add error:", result);
            }
        })
        .catch(error=>{
            console.error("Add failed:", error);
            alert("An error occurred while adding the admin user.");
        });
    },
    UpdateAdminUser(){
        let updateAdminUserRequestUrl = this.baseUrl + "AdminUsers/UpdateAdminUser";
        let updateAdminUserRequestOptions = {
            method:"POST",
            headers:{
                "Authorization":`Bearer ${localStorage.token}`,
                "Content-Type":"application/json"
            },
            body:JSON.stringify(
                {
                    "userId" : this.selectedAdminUser.userId,
                    "name": this.selectedAdminUser.name,
                    "password": this.selectedAdminUser.password,
                    "description": this.selectedAdminUser.description,
                    "roleId": this.selectedAdminUser.roleId
                }
            )
        };

        fetch(updateAdminUserRequestUrl, updateAdminUserRequestOptions)
        .then(async response=>{
            const result = await response.json();

            if(response.ok){
                alert("Admin user updated successfully!");
                await this.getAdminUsersList();
            }
            else{
                alert("Failed to update admin user. Please try again.");
                console.error("Update error:", result);
            }
        })
        .catch(error=>{
            console.error("Update failed:", error);
            alert("An error occurred while updating the admin user.");
        });
    },
    ShowAddAdminUserModal(){
        this.isNewAdminUserToAdd = true;
        this.selectedAdminUser = {
            userId : 0,
            name : "",
            password: "",
            description: "",
            roleId: this.roles.length ? this.roles[0].roleId : null
        };
        document.getElementById("adminUserDetailModalButton").click();
    },
    ShowUpdateModal(adminUser){
        this.isNewAdminUserToAdd = false;

        this.selectedAdminUser = { ...toRaw(adminUser), password: "" };

        document.getElementById("adminUserDetailModalButton").click();
    }
},
mounted(){
    if(!isBoss()){
        this.$router.replace("/schedule");
        return;
    }

    this.getRolesList();
    this.getAdminUsersList();
},

})
</script>
<style>
</style>
